import { IChangePropertyPayload } from '@dash/editForm';
import {
  ChangePropertyAction,
  ClearStateAction,
  LoadFormDataAction,
  LoadFormDataErrorAction,
  LoadFormDataSuccessAction,
  LoadTemplateAction,
  LoadTemplateErrorAction,
  LoadTemplateSuccessAction,
  UploadTrustedTalentAction,
  UploadTrustedTalentErrorAction,
  UploadTrustedTalentSuccessAction,
} from './actions.d';
import actionTypes from './actionTypes';
import { Attribute, FieldTypes, ILoadFormDataSuccessPayload, IUploadApplicantPayload } from './types';

const actions = {
  loadFormData: (): LoadFormDataAction => ({
    type: actionTypes.LOAD_FORM_DATA,
  }),
  loadFormDataSuccess: (payload: ILoadFormDataSuccessPayload): LoadFormDataSuccessAction => ({
    type: actionTypes.LOAD_FORM_DATA_SUCCESS,
    payload,
  }),
  loadFormDataError: (): LoadFormDataErrorAction => ({
    type: actionTypes.LOAD_FORM_DATA_ERROR,
  }),
  changeProperty: (payload: IChangePropertyPayload<Attribute, FieldTypes>): ChangePropertyAction => ({
    type: actionTypes.CHANGE_PROPERTY,
    payload,
  }),
  loadTemplate: (): LoadTemplateAction => ({
    type: actionTypes.LOAD_TEMPLATE,
  }),
  loadTemplateSuccess: (): LoadTemplateSuccessAction => ({
    type: actionTypes.LOAD_TEMPLATE_SUCCESS,
  }),
  loadTemplateError: (): LoadTemplateErrorAction => ({
    type: actionTypes.LOAD_TEMPLATE_ERROR,
  }),
  uploadTrustedTalent: (payload: IUploadApplicantPayload): UploadTrustedTalentAction => ({
    type: actionTypes.UPLOAD_TRUSTED_TALENT,
    payload,
  }),
  uploadTrustedTalentSuccess: (): UploadTrustedTalentSuccessAction => ({
    type: actionTypes.UPLOAD_TRUSTED_TALENT_SUCCESS,
  }),
  uploadTrustedTalentError: (): UploadTrustedTalentErrorAction => ({
    type: actionTypes.UPLOAD_TRUSTED_TALENT_ERROR,
  }),
  clearState: (): ClearStateAction => ({
    type: actionTypes.CLEAR_STATE,
  }),
};

export default actions;
